import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { FormControl, FormGroup, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { HelperArray } from '../_classi/HelperArray';
import { FaqService } from '../_servizi/faq.service';
import { StepService } from '../_servizi/step.service';
import { StripeService } from '../_servizi/stripe.service';
import { StripeComponent } from '../stripe/stripe.component';
import { CarrelloViniService } from '../_servizi/carrelloVini.service';
import * as moment from 'moment';
import { map, Observable, startWith } from 'rxjs';
import { SpedizioniService } from '../_servizi/spedizioni.service';
import { InitPagamento } from '../_classi/InitPagamento';
import { AnagraficaF } from '../_classi/AnagraficaF';
import { AnagraficaR } from '../_classi/AnagraficaR';
import { AnagraficaSP } from '../_classi/AnagraficaSP';
import { ClientiService } from '../_servizi/clienti.service';
import { StripeMetadata } from '../_classi/StripeMetadata';
import { InitPagamentoStripe } from '../_classi/InitPagamentoStripe';
import { CompletaPagamentoZero } from '../_classi/CompletaPagamentoZero';
import { PagamentiService } from '../_servizi/pagamenti.service';
import { MessageServiceService } from '../_servizi/message-service.service';
import { v4 as uuidv4 } from 'uuid';
import { DateAdapter } from '@angular/material/core';
import { CantinaService } from '../_servizi/cantina.service';
import { AppoggioService } from '../_servizi/appoggio.service';
import { CookieService } from 'ngx-cookie-service';
import { MatDialog } from '@angular/material/dialog';
import { DialogScontoCarrelloAlertComponent } from '../_dialoghi/dialog-sconto-carrello-alert/dialog-sconto-carrello-alert.component';
@Component({
  selector: 'app-step2',
  templateUrl: './step2.component.html',
  styleUrls: ['./step2.component.css'],
  animations: [
    trigger('flipState', [
      state('active', style({
        transform: 'rotateY(179deg)'
      })),
      state('inactive', style({
        transform: 'rotateY(0)'
      })),
      transition('active => inactive', animate('500ms ease-out')),
      transition('inactive => active', animate('500ms ease-in'))
    ])
  ]
})
export class Step2Component implements OnInit, AfterViewInit {

  totaleRiga(riga): number {
    let totRiga = parseFloat(riga.totale);
    if (riga.checksupplemento === '1' && this.formCarrello.value.tipoPagamento === "CANTINASC") {
      totRiga += (parseFloat(riga.supplemento) * riga.nadulti)
      totRiga += (parseFloat(riga.supplemento) * riga.nadulti_solovisita)
    }
    return totRiga;
  }

  getTotaleVini(vino) {
    let totale = 0;
    totale += parseFloat(vino.totaleVino);
    totale += parseFloat(vino.costoSpedizioneCliente);
    totale += vino.sconto;

    for (const vinoItem of vino.vini) {
      for (const buonoItem of vinoItem.buoni) {
        totale += parseFloat(buonoItem.totale);
      }
    }

    const riga = vino;
    const idCantina = riga.idCantina;
    const codici_per_cantina = this.listaCodiciScontoCarrello.filter(codice => codice.idCantina === idCantina).length > 0 ?
      this.listaCodiciScontoCarrello.filter(codice => codice.idCantina === idCantina) : null;

    riga.sconto_codici = [];
    let i = 0;
    if (codici_per_cantina && codici_per_cantina.length > 0) {
      for (const codice of codici_per_cantina) {
        if (codice.tipo_codice === '1') {
          if (parseInt(codice.minimo_bottiglie, 10) <= parseInt(riga.qta_abilitati, 10)) {
            if (codice.tipo_unita_codice === '0') {
              totale += (codice.valore * -1);
            } else {
              totale += ((parseFloat(riga.totale_abilitati) + riga.sconto) / 100 * codice.valore) * -1;
            } riga.sconto_codici[i] = codice;
          }
        } else {
          if (parseFloat(codice.minimo_totale) <= parseFloat(riga.totale_abilitati)) {
            if (codice.tipo_unita_codice === '0') {
              totale += (codice.valore * -1);
            } else {
              totale += ((parseFloat(riga.totale_abilitati) + riga.sconto) / 100 * codice.valore) * -1;
            } riga.sconto_codici[i] = codice;
          }
        }
        i++;
      }
    }

    return totale;
  }

  getTotaleBuonoCantina(buonoCantina) {
    let prz = parseFloat(buonoCantina.totale);
    if (buonoCantina.pacchetti != null) {
      prz += parseFloat(buonoCantina.pacchetti[0]['costoFinale']);
    }
    return prz;
  }

  getTotalePacchetti(pacchetto) {
    let prz = 0;
    if (pacchetto.pacchetti != null) {
      prz += parseFloat(pacchetto.pacchetti[0]['costoFinale']);
    }
    return prz;
  }

  get totale(): number {
    let tot = 0;

    for (const carrello of this.carrelloVisite) {
      if (carrello.promo !== '') {
        this.promotrovata = true;
      }
      tot += this.totaleRiga(carrello);
    }

    for (const riga of this.carrelloVini) {
      tot += this.getTotaleVini(riga);
    }

    for (const buoniCantina of this.carrelloBuoniCantina) {
      tot += this.getTotaleBuonoCantina(buoniCantina);
    }

    for (const riga of this.carrelloPacchetti) {
      tot += this.getTotalePacchetti(riga);
    }

    return tot;
  }

  get totalecarrello(): number {
    return this.totale;
  }

  getCodiceFormCarrello(): any {
    let codiceForm = null;
    for (const visita of this.carrelloVisite) {
      codiceForm = visita.codiceForm;
    }

    for (const buonoCantina of this.carrelloBuoniCantina) {
      codiceForm = buonoCantina.codiceForm;
    }

    for (const vino of this.carrelloVini) {
      codiceForm = vino.codiceForm;
    }

    return codiceForm;
  }

  flip = 'inactive';
  isFront = true;
  contentHeight;


  faqs = [];

  @ViewChild('contenitore') contenitore: ElementRef;
  @ViewChild('front') front: ElementRef;
  @ViewChild('back') back: ElementRef;

  @ViewChild(StripeComponent) stripeComponent: StripeComponent;

  step = 0;

  lingua: string;

  patternTelefono = '^[0-9]{6,20}$';
  patternCAPita = '^[0-9]{5}$';
  statoSelezionatoDefault = 'IT';

  form: UntypedFormGroup;
  formTipoPagamento: UntypedFormGroup;

  nomeFormControl = new UntypedFormControl('', [
    Validators.required
  ]);
  cognomeFormControl = new UntypedFormControl('', [
    Validators.required
  ]);
  emailFormControl = new UntypedFormControl('', [
    Validators.required,
    Validators.email,
  ]);
  nazioneFormControl = new UntypedFormControl(this.statoSelezionatoDefault, [
    Validators.required
  ]);
  capFormControl = new UntypedFormControl('', [
    Validators.required,
    Validators.pattern(this.patternCAPita)
  ]);
  telefonoFormControl = new UntypedFormControl('', [
    Validators.required,
    Validators.pattern(this.patternTelefono)
  ]);


  tipoDocFormControl = new UntypedFormControl('R', [
    Validators.required
  ]);
  ricevutaFormControl = new UntypedFormControl('', [
    Validators.required
  ]);

  fDenominazioneFormControl = new UntypedFormControl('');
  fIndirizzoFormControl = new UntypedFormControl('');
  fCapFormControl = new UntypedFormControl('');
  fCittaFormControl = new UntypedFormControl('');
  fProvinciaFormControl = new UntypedFormControl('');
  fPivaFormControl = new UntypedFormControl('');
  fFeFormControl = new UntypedFormControl('');

  provincie: any = [];

  rNomeFormControl = new UntypedFormControl('');
  rCognomeFormControl = new UntypedFormControl('');
  rIndirizzoFormControl = new UntypedFormControl('');
  rCapFormControl = new UntypedFormControl('');
  rCittaFormControl = new UntypedFormControl('');
  rProvinciaFormControl = new UntypedFormControl('');
  rCfFormControl = new UntypedFormControl('');

  p1FormControl = new UntypedFormControl('', [
    Validators.required,
    Validators.pattern('Y'),
  ]);
  p2FormControl = new UntypedFormControl('', [
    Validators.required
  ]);
  p3FormControl = new UntypedFormControl('', [
    Validators.required
  ]);

  tipoPagFormControl = new UntypedFormControl(null, [
    Validators.required
  ]);

  noteOrdineFormControl = new UntypedFormControl('');

  public get currentVisita(): any {
    return this.stepService.currentVisita;
  }

  idCookie: any = null;

  //SPEDIZIONE

  sceltaWineshopSC = false;

  formSpedizione: FormGroup;
  spDenominazioneFormControl = new FormControl('', [Validators.required]);
  spIndirizzoFormControl = new FormControl('', [Validators.required]);
  spHouseNumberFormControl = new FormControl('', [Validators.required]);
  spCapFormControl = new FormControl('', [Validators.required]);
  spCittaFormControl = new FormControl('', [Validators.required]);
  spProvinciaFormControl = new FormControl('', []);
  spTelefonoFormControl = new FormControl('', [Validators.required]);
  spCountryFormControl = new FormControl();
  spNoteFormControl = new FormControl();


  options = HelperArray.STATI;
  statiSelect2Data = HelperArray.STATISELECT2DATA;

  optionsProvince = HelperArray.STATICONPROVINCE;
  statiProvinceSelect2Data = HelperArray.STATICONPROVINCESELECT2DATA;

  listaProvince = [];
  listaCitta = [];
  listaZip = [];
  hintCapRange = false;

  oldProvincia = null;

  filteredProvince: Observable<any[]>;
  filteredCitta: Observable<any[]>;
  filteredZip: Observable<any[]>;

  provinciaSelezionata = false;
  cittaSelezionata = false;


  //CARRELLO ___________

  loadingCarrello = false;

  formCarrello: FormGroup;

  carrelloVisite = [];
  carrelloVini = [];
  carrelloBuoniCantina = [];
  carrelloPacchetti = [];

  promotrovata = false;

  banca: any;
  bancaPagaInCantina: any;

  adm_prenota = true;
  pc = true;
  adm_prenotaSC = true;
  pagaCantina = true;
  adm_paga_wineshop_SC = true;
  pagamentoWineshopSC = true;

  oltreTOTgg = false;
  ngg = 26;

  linkprivacy = null;
  linkcondizioni = null;

  //PAGAMENTO _______________
  valori = null;
  initPagamentoStripeValori: InitPagamentoStripe;
  isCodiceFormMasterPresente = false;
  linguaCorrente: string;

  codiceFormOk = false;

  //ESTERO
  paeseSpedizione = null;
  adm_spedizione_estero = true;
  erroreEstero = false;
  loadingEstero = false;
  prefix = null;

  //CODICI CARRELLO
  codiceScontoCarrello = null;
  listaCodiciScontoCarrello = [];
  loadingCodici = false;

  check_animali = false;
  check_vegani = false;
  check_celiaci = false;
  check_vegetariani = false;
  count_vegani = 1;
  count_celiaci = 1;
  count_vegetariani = 1;

  nome = null;
  cognome = null;
  telefono = null;

  constructor(
    public translate: TranslateService,
    private formBuilder: UntypedFormBuilder,
    private stepService: StepService,
    private stripeService: StripeService,
    private faqService: FaqService,
    private router: Router,
    private route: ActivatedRoute,
    private carrelloService: CarrelloViniService,
    private spedizioniService: SpedizioniService,
    private clientiService: ClientiService,
    private pagamentiService: PagamentiService,
    private messageService: MessageServiceService,
    private adapter: DateAdapter<any>,
    private cantinaService: CantinaService,
    private appoggioService: AppoggioService,
    public dialog: MatDialog
  ) {

    this.spedizioniService.getPublicProvince().subscribe(result => {
      this.provincie = result;
    });

    this.stepService.currentStep = 2;

    this.route.paramMap.subscribe((params) => {
      this.linguaCorrente = params.get('lingua');


      if (this.linguaCorrente && this.linguaCorrente !== 'null' && this.linguaCorrente !== undefined && this.linguaCorrente !== 'undefined') {
        this.translate.use(this.linguaCorrente);
      } else {
        this.translate.use('it');
      }

      this.adapter.setLocale(this.translate.currentLang);
    });

    this.formSpedizione = formBuilder.group({
      denominazione_sp: this.spDenominazioneFormControl,
      indirizzo_sp: this.spIndirizzoFormControl,
      house_number_sp: this.spHouseNumberFormControl,
      cap_sp: this.spCapFormControl,
      citta_sp: this.spCittaFormControl,
      provincia_sp: this.spProvinciaFormControl,
      telefono_sp: this.spTelefonoFormControl,
      country_sp: this.spCountryFormControl,
      note_sp: this.spNoteFormControl,
      country_text_sp: new FormControl('')
    });

    this.formCarrello = this.formBuilder.group({
      lingua: new UntypedFormControl(translate.currentLang),
      email: this.emailFormControl,
      nome: this.nomeFormControl,
      cognome: this.cognomeFormControl,
      nazione: this.nazioneFormControl,
      cap: this.capFormControl,
      telefono: this.telefonoFormControl,
      tipoDocFormControl: this.tipoDocFormControl,
      fDenominazione: this.fDenominazioneFormControl,
      fIndirizzo: this.fIndirizzoFormControl,
      fCap: this.fCapFormControl,
      fCitta: this.fCittaFormControl,
      fProvincia: this.fProvinciaFormControl,
      fPiva: this.fPivaFormControl,
      fFe: this.fFeFormControl,

      noteOrdine: this.noteOrdineFormControl,

      nome_r: this.rNomeFormControl,
      cognome_r: this.rCognomeFormControl,
      indirizzo_r: this.rIndirizzoFormControl,
      cap_r: this.rCapFormControl,
      citta_r: this.rCittaFormControl,
      provincia_r: this.rProvinciaFormControl,
      cf_r: this.rCfFormControl,

      p1: this.p1FormControl,
      p2: this.p2FormControl,
      p3: this.p3FormControl,
      idFacebook: null,
      idGoogle: null,
      profileImage: null
    });

    this.formTipoPagamento = new UntypedFormGroup({
      tipoPagamento: this.tipoPagFormControl
    });

    this.getFaq(7, 'it');

    this.formCarrello.get('nome').valueChanges.subscribe(val => {
      this.nome = val;
      if (this.stripeComponent) {
        this.stripeComponent.setTitolare(this.formCarrello.get('cognome').value + ' ' + this.formCarrello.get('nome').value);
      }
    });
    this.formCarrello.get('cognome').valueChanges.subscribe(val => {
      this.cognome = val;
      if (this.stripeComponent) {
        this.stripeComponent.setTitolare(this.formCarrello.get('cognome').value + ' ' + this.formCarrello.get('nome').value);
      }
    });
    this.formCarrello.get('email').valueChanges.subscribe(val => {
      if (this.stripeComponent) {
        this.stripeComponent.setEmail(this.formCarrello.get('email').value);
      }
    });
    this.formCarrello.get('telefono').valueChanges.subscribe(val => {
      this.telefono = val;
      if (this.stripeComponent) {
        this.stripeComponent.setTelefono(this.formCarrello.get('telefono').value);
      }
    });
    this.formTipoPagamento.get('tipoPagamento').valueChanges.subscribe(val => {
      if (this.valori && this.valori.default) {
        this.valori.default.tipoPagamento = val;
      }
    });
  }

  noWhitespaceValidator(control: any) {
    const isWhitespace = (control.value || '').trim().length === 0;
    return isWhitespace ? { whitespace: true } : null;
  }

  ngOnInit(): void {

    this.route.paramMap.subscribe((params) => {
      let idCookie = params.get('idCookie');

      if (idCookie && idCookie !== 'null') {
        this.messageService.setIdCookie(idCookie);
      } else {
        idCookie = uuidv4();
        this.messageService.sendIdCookie(idCookie);
        this.messageService.setIdCookie(idCookie);
      }

      this.caricaCarrello();
    });


    if (this.checkPagamentoZero()) {
      this.formTipoPagamento.patchValue({
        tipoPagamento: 'CC'
      });
    }

    if (this.clientiService.getFormCliente().salvata) {
      const forms = this.clientiService.getFormCliente();
      this.formCarrello.patchValue(forms.formCarrello);
      this.formSpedizione.patchValue(forms.formSpedizione);
      this.formTipoPagamento.patchValue(forms.formTipoPagamento);
    }
  }

  ngAfterViewInit(): void {
    this.tipoDocChange({ value: 'R' });
    setTimeout(() => {
      if (this.front) {
        const frontHeight = this.front.nativeElement.scrollHeight;
        this.contentHeight = frontHeight;
      }
    }, 0);


  }

  setFormSpedizione(form) {
    this.formSpedizione = form;
  }

  //CARRELLO ______________________

  caricaCarrello() {
    this.carrelloService.getCarrello()
      .subscribe(result => {
        this.carrelloVisite = result.carrello;
        this.carrelloVini = result.carrello_vini;
        this.carrelloBuoniCantina = result.carrello_buoni_cantina;
        this.carrelloPacchetti = result.carrello_pacchetti;

        this.banca = result.banca;
        this.bancaPagaInCantina = result.bancaPagaInCantina;

        const oggi = moment();

        let codiceForm = null;

        for (const rigacarrello of this.carrelloVisite) {

          codiceForm = rigacarrello.codiceFormMaster ? rigacarrello.codiceFormMaster : rigacarrello.codiceForm;
          this.isCodiceFormMasterPresente = rigacarrello.codiceFormMaster ? true : false;

          if (rigacarrello.adm_prenota === '0') { this.adm_prenota = false; }
          if (rigacarrello.pc === '0') { this.pc = false; }
          if (rigacarrello.adm_prenotaSC === '0') { this.adm_prenotaSC = false; }

          if (rigacarrello.pagaCantina === '0') { this.pagaCantina = false; }

          this.adm_paga_wineshop_SC = false;
          this.pagamentoWineshopSC = false;

          const datavisita = moment(rigacarrello.dataora);
          if (rigacarrello.adm_prenotaSC !== '1') {
            const diffgg = datavisita.diff(oggi, 'days');
            if (diffgg >= this.ngg) { this.oltreTOTgg = true; }
          }
        }

        for (const rigavini of this.carrelloVini) {
          rigavini.qta = parseInt(rigavini.qta);
          rigavini.pezziMin = parseInt(rigavini.pezziMin);
          codiceForm = rigavini.codiceForm;
          if (rigavini.adm_paga_wineshop_SC === '0') { this.adm_paga_wineshop_SC = false; }
          if (rigavini.adm_spedizione_estero === '0') { this.adm_spedizione_estero = false; }
        }

        for (const rigapacchetti of this.carrelloPacchetti) {
          codiceForm = rigapacchetti.codiceForm;
          if (rigapacchetti.adm_paga_wineshop_SC === '0') { this.adm_paga_wineshop_SC = false; }
          if (rigapacchetti.adm_spedizione_estero === '0') { this.adm_spedizione_estero = false; }
        }

        if (!this.adm_spedizione_estero) {
          this.paeseSpedizione = 'IT';
        }

        for (const buonocantina of this.carrelloBuoniCantina) {
          codiceForm = buonocantina.codiceFormMaster ? buonocantina.codiceFormMaster : buonocantina.codiceForm;
          this.isCodiceFormMasterPresente = buonocantina.codiceFormMaster ? true : false;

          this.adm_paga_wineshop_SC = false;
          this.pagamentoWineshopSC = false;
        }

        for (const rigavini of this.carrelloVini) {
          if (rigavini.adm_paga_wineshop_SC === '0') { this.adm_paga_wineshop_SC = false; this.pagamentoWineshopSC = false; }
        }

        for (const rigavini of this.carrelloPacchetti) {
          if (rigavini.adm_paga_wineshop_SC === '0') { this.adm_paga_wineshop_SC = false; this.pagamentoWineshopSC = false; }
        }

        if (codiceForm) {
          this.cantinaService.getStato(codiceForm)
            .subscribe(result => {
              if (result && result.length > 0) {

                const cantina = result[0];

                this.linkprivacy = cantina['linkprivacy'] !== '' ? cantina['linkprivacy'] : null;
                this.linkcondizioni = cantina['linkcondizioni'] !== '' ? cantina['linkcondizioni'] : null;

                if (cantina['infoStripe'] != null) {
                  const infoStripe = {
                    abilitatoAccount: cantina['infoStripe']['abilitatoAccountStripe'] === '1' ? true : false,
                    abilitatoProduzione: cantina['infoStripe']['abilitatoProduzione'] === '1' ? true : false,
                    api_key: cantina['infoStripe']['abilitatoProduzione'] === '1' ? cantina['infoStripe']['apiKeyStripeProduzione'] : cantina['infoStripe']['apiKeyStripeTest'],
                    endpoint_secret: cantina['infoStripe']['abilitatoProduzione'] === '1' ? cantina['infoStripe']['endpointSecretProduzione'] : cantina['infoStripe']['endpointSecretTest']
                  }
                  this.stripeService.setInfoStripe(infoStripe);
                } else {
                  this.stripeService.setInfoStripe(null);
                }

                this.appoggioService.setColoriIframe(cantina);
                this.codiceFormOk = true;
              } else {
                this.codiceFormOk = true;
              }
            });
        } else {
          this.codiceFormOk = true;
        }

        this.checkCodiciSconto();

        this.loadingCarrello = false;
      });
  }

  getLinkPrivacy() {
    return this.linkprivacy ? this.linkprivacy : 'https://www.cantine.wine/privacy?tab=0';

  }

  getLinkCondizioni() {
    return this.linkcondizioni ? this.linkcondizioni : 'https://www.cantine.wine/privacy?tab=2';


  }

  pezziMinViniOk() {
    let result = true;
    for (const cantina of this.carrelloVini) {
      if (cantina.pezziMin > cantina.qta) {
        return false;
      }
    }
    return result;
  }

  isMultipliVinoOK() {
    let result = true;
    for (const cantina of this.carrelloVini) {
      if (cantina.qta % cantina.multipli !== 0) {
        return false;
      }
    }
    return result;
  }


  controllaCantina() {
    return false;
  }

  controllaCantinaSC() {
    if (
      this.oltreTOTgg ||
      this.adm_prenota ||
      !this.pc ||
      !this.adm_prenotaSC ||
      this.promotrovata ||
      this.totalecarrello === 0 ||
      this.carrelloVini.length > 0 ||
      this.carrelloBuoniCantina.length > 0 ||
      this.carrelloPacchetti.length > 0
    ) {
      return false;
    } else {
      return true;
    }
  }

  controllaWineshopSC() {
    if (
      !this.adm_paga_wineshop_SC ||
      this.carrelloBuoniCantina.length > 0 ||
      this.promotrovata ||
      (this.carrelloVini.length == 0 && this.carrelloPacchetti.length == 0) ||
      this.carrelloVisite.length > 0
    ) {
      return false;
    } else {
      return true;
    }
  }

  pagaWineshopSC(sc) {
    this.sceltaWineshopSC = true;
    if (sc) {
      Object.keys(this.formSpedizione.controls).forEach(key => {
        this.formSpedizione.get(key).clearValidators();
        this.formSpedizione.get(key).updateValueAndValidity();
      });
      this.pagamentoWineshopSC = true;
      this.gestisciAvanzamento();
    } else {
      this.pagamentoWineshopSC = false;
    }
  }

  carrelloHasSupplemento() {
    let ok = false;
    let tot = 0;
    for (const prenotazione of this.carrelloVisite) {
      if (this.controllaCantinaSC() && prenotazione.checksupplemento === '1') {
        tot = parseFloat(prenotazione.supplemento);
      }
    }
    if (tot > 0) {
      ok = true;
    }

    const ret = {
      has: ok,
      supp: tot
    }

    return ret;
  }

  getSupplementoRiga(riga) {
    return parseFloat(riga.supplemento) * parseInt(riga.nposti, 10);
  }

  getTotaleRigaConSupplemento(riga) {
    return parseFloat(riga.totale) + this.getSupplementoRiga(riga);
  }

  isPresentWine() {
    let presenti = false;

    this.carrelloBuoniCantina.forEach(buono => {
      if (buono.pacchetti && buono.pacchetti.length > 0) {
        presenti = true;
      }
    });

    this.carrelloPacchetti.forEach(pacchetti => {
      if (pacchetti.pacchetti && pacchetti.pacchetti.length > 0) {
        presenti = true;
      }
    });

    if (this.carrelloVini.length > 0) {
      presenti = true;
    }
    return presenti;
  }

  controllaZero() {
    if (this.totalecarrello !== 0) {
      return false;
    } else {
      return true;
    }
  }

  controllaRichiediDatiFiscaliRicevuta(): boolean {
    let trovato = false;

    for (const rigaCarrello of this.carrelloVisite) {
      if (rigaCarrello.richiediDatiFiscaliRicevuta === '1') {
        trovato = true;
      }
    }

    for (const rigaCarrello of this.carrelloBuoniCantina) {
      if (rigaCarrello.richiediDatiFiscaliRicevuta === '1') {
        trovato = true;
      }
    }

    for (const rigaCarrello of this.carrelloVini) {
      if (rigaCarrello.richiediDatiFiscaliRicevuta === '1') {
        trovato = true;
      }
    }

    return trovato;
  }

  isConfermabili() {
    let ar = this.filtraConfermabili();
    return ar;
  }

  filtraConfermabili() {
    let confermabili = false;
    for (const riga of this.carrelloVisite) {
      if (riga.confermabile === '1') {
        confermabili = true;
      }
    }
    return confermabili;
  }

  checkPagamentoZero(): boolean {
    if (this.totalecarrello === 0) {
      return true;
    } else {
      return false;
    }
  }

  setStep(index: number) {
    if (this.step === 0) {
      if (this.stripeComponent) {
        this.stripeComponent.setDatiUtente(this.formCarrello.value);
      }
    } else if (this.step === 1) {
      if (this.stripeComponent) {
        this.stripeComponent.setDatiPagamento(this.formTipoPagamento.value);
      }
    }
    this.step = index;
  }

  nextStep() {
    if (this.step === 0) {
      if (this.stripeComponent) {
        this.stripeComponent.setDatiUtente(this.formCarrello.value);
        this.step++;
      } else {
        this.step++;
      }
    } else if (this.step === 1 && !this.isCantinaSC() && !this.isWineshopSC() && !this.checkPagamentoZero()) {
      if (this.stripeComponent) {
        this.stripeComponent.setDatiPagamento(this.formTipoPagamento.value);
      }
      this.step++;
    } else {
      this.step++;
    }
  }

  prevStep() {
    if (this.step === 2) {
      if (this.checkPagamentoZero()) {
        this.step -= 2;
      } else {
        this.step--;
      }
    } else {
      this.step--;
    }
  }

  tipoDocChange(event) {
    if (event.value === 'F') {
      this.fDenominazioneFormControl.setValidators([Validators.required, this.noWhitespaceValidator]);
      this.fIndirizzoFormControl.setValidators([Validators.required, this.noWhitespaceValidator]);
      this.fCapFormControl.setValidators([Validators.required, this.noWhitespaceValidator]);
      this.fCittaFormControl.setValidators([Validators.required, this.noWhitespaceValidator]);
      this.fProvinciaFormControl.setValidators([Validators.required, this.noWhitespaceValidator]);
      this.fPivaFormControl.setValidators([Validators.required, this.noWhitespaceValidator]);
      this.fFeFormControl.setValidators([Validators.required, this.noWhitespaceValidator]);

      this.rNomeFormControl.clearValidators();
      this.rCognomeFormControl.clearValidators();
      this.rIndirizzoFormControl.clearValidators();
      this.rCapFormControl.clearValidators();
      this.rCittaFormControl.clearValidators();
      this.rProvinciaFormControl.clearValidators();
      this.rCfFormControl.clearValidators();

    } else {
      this.fDenominazioneFormControl.clearValidators();
      this.fIndirizzoFormControl.clearValidators();
      this.fCapFormControl.clearValidators();
      this.fCittaFormControl.clearValidators();
      this.fProvinciaFormControl.clearValidators();
      this.fPivaFormControl.clearValidators();
      this.fFeFormControl.clearValidators();
    }
    if (event.value === 'R') {
      if (this.controllaRichiediDatiFiscaliRicevuta()) {
        this.rNomeFormControl.setValidators([Validators.required, this.noWhitespaceValidator]);
        this.rCognomeFormControl.setValidators([Validators.required, this.noWhitespaceValidator]);
        this.rIndirizzoFormControl.setValidators([Validators.required, this.noWhitespaceValidator]);
        this.rCapFormControl.setValidators([Validators.required, this.noWhitespaceValidator]);
        this.rCittaFormControl.setValidators([Validators.required, this.noWhitespaceValidator]);
        this.rProvinciaFormControl.setValidators([Validators.required, this.noWhitespaceValidator]);
        this.rCfFormControl.setValidators([Validators.required, this.noWhitespaceValidator]);
      } else {
        this.rNomeFormControl.clearValidators();
        this.rCognomeFormControl.clearValidators();
        this.rIndirizzoFormControl.clearValidators();
        this.rCapFormControl.clearValidators();
        this.rCittaFormControl.clearValidators();
        this.rProvinciaFormControl.clearValidators();
        this.rCfFormControl.clearValidators();
      }

      this.fDenominazioneFormControl.clearValidators();
      this.fIndirizzoFormControl.clearValidators();
      this.fCapFormControl.clearValidators();
      this.fCittaFormControl.clearValidators();
      this.fProvinciaFormControl.clearValidators();
      this.fPivaFormControl.clearValidators();
      this.fFeFormControl.clearValidators();

    } else {
      this.rNomeFormControl.clearValidators();
      this.rCognomeFormControl.clearValidators();
      this.rIndirizzoFormControl.clearValidators();
      this.rCapFormControl.clearValidators();
      this.rCittaFormControl.clearValidators();
      this.rProvinciaFormControl.clearValidators();
      this.rCfFormControl.clearValidators();
    }

    this.rNomeFormControl.updateValueAndValidity();
    this.rCognomeFormControl.updateValueAndValidity();
    this.rIndirizzoFormControl.updateValueAndValidity();
    this.rCapFormControl.updateValueAndValidity();
    this.rCittaFormControl.updateValueAndValidity();
    this.rProvinciaFormControl.updateValueAndValidity();
    this.rCfFormControl.updateValueAndValidity();

    this.fDenominazioneFormControl.updateValueAndValidity();
    this.fIndirizzoFormControl.updateValueAndValidity();
    this.fCapFormControl.updateValueAndValidity();
    this.fCittaFormControl.updateValueAndValidity();
    this.fProvinciaFormControl.updateValueAndValidity();
    this.fPivaFormControl.updateValueAndValidity();
    this.fFeFormControl.updateValueAndValidity();
  }

  cambiaNazione() {
    if (this.nazioneFormControl.value === 'IT') {
      this.capFormControl.setValidators([
        Validators.required,
        Validators.pattern(this.patternCAPita)
      ]);
    } else {
      this.capFormControl.clearValidators();
    }
    this.capFormControl.updateValueAndValidity();
    this.capFormControl.markAsTouched();
  }

  completa() {

    let isStripeCantina = false;
    const infoStripe = this.stripeService.getInfoStripe();
    if (infoStripe && infoStripe['abilitatoAccount']) {
      isStripeCantina = true;
    }

    this.clientiService.inserisciClienteNF(this.valori.utente).subscribe(result => {
      if (result['risultato']) {
        this.valori.utente.id = result['idCliente'];
      }

      const initPagamentoValori: InitPagamento = new InitPagamento(
        this.valori.default.tipoPagamento,
        false,
        true,
        isStripeCantina,
        this.valori.default.isCodiceFormMasterPresente,
        this.translate.currentLang,
        this.valori.utente.id,
        this.valori.fiscali.tipoDocFormControl === 'F' ? 1 : 0,
        this.valori.default.noteordine,
        new AnagraficaF(
          this.valori.fiscali.denominazione_f,
          this.valori.fiscali.indirizzo_f,
          this.valori.fiscali.cap_f,
          this.valori.fiscali.citta_f,
          this.valori.fiscali.provincia_f,
          this.valori.fiscali.cf_f,
          this.valori.fiscali.fe_f
        ),
        new AnagraficaR(
          this.valori.fiscali.nome_r,
          this.valori.fiscali.cognome_r,
          this.valori.fiscali.indirizzo_r,
          this.valori.fiscali.cap_r,
          this.valori.fiscali.citta_r,
          this.valori.fiscali.provincia_r,
          this.valori.fiscali.cf_r
        ),
        new AnagraficaSP(
          this.valori.spedizione.denominazione_sp,
          this.valori.spedizione.indirizzo_sp,
          this.valori.spedizione.cap_sp,
          this.valori.spedizione.citta_sp,
          this.valori.spedizione.provincia_sp,
          this.valori.spedizione.telefono_sp,
          this.valori.spedizione.house_number_sp
        ),
        0,
        0,
        null,
        this.listaCodiciScontoCarrello
      );

      this.pagamentiService.initPagamento(initPagamentoValori).subscribe(result => {
        if (result.risultato) {

          this.initPagamentoStripeValori = new InitPagamentoStripe(
            result.totaledapagare,
            new StripeMetadata(
              result.shopID,
              result.info2,
              result.info1,
              "",
              result.info3,
              this.valori.utente.id,
              this.valori.utente.cognome + " " + this.valori.utente.nome,
              this.valori.utente.email,
              this.valori.utente.telefono,
              this.translate.currentLang,
              this.valori.default.noteordine,
              0,
              0
            )
          )

          const terminaPagamentoZeroValori = new CompletaPagamentoZero(
            this.valori.utente.id,
            result.shopID,
            this.translate.currentLang,
            result.cantinaSC,
            result.wineshopSC
          );

          this.pagamentiService.completaPagamentoZero(terminaPagamentoZeroValori).subscribe(resP0 => {
            let stato = "";
            if (resP0.risultato) {
              stato = 'ok';
              this.router.navigateByUrl('step3/' + stato);
            } else {
              stato = 'ko';
              this.router.navigateByUrl('step3/' + stato);
            }
          });

        }
      });
    });

  }

  isCantinaSC() {
    if (this.formTipoPagamento.value.tipoPagamento === 'CANTINASC') {
      return true;
    } else {
      return false;
    }
  }

  isWineshopSC() {
    if (this.formTipoPagamento.value.tipoPagamento === 'WINESHOPSC') {
      return true;
    } else {
      return false;
    }
  }

  toggleFlip() {
    this.flip = (this.flip === 'inactive') ? 'active' : 'inactive';

    /*
    const frontHeight =  this.front.nativeElement.style.height;
    const backHeight =  this.back.nativeElement.style.height;
    const frontHeight =  this.front.nativeElement.offsetHeight;
    const backHeight =  this.back.nativeElement.offsetHeight;
    */

    let height = 0;


    if (this.isFront) {
      this.isFront = false;

      height = this.back.nativeElement.scrollHeight;
      console.log(this.back.nativeElement.scrollHeight);
      this.contentHeight = height;

    } else {
      this.isFront = true;

      height = this.front.nativeElement.scrollHeight;
      console.log(this.front.nativeElement.scrollHeight);
      this.contentHeight = height;

    }
    // this.contenitore.nativeElement.style.height.px = this.contentHeight;
  }

  ridimensioneBack() {
    const height = this.back.nativeElement.scrollHeight;
    console.log(this.back.nativeElement.scrollHeight);
    this.contentHeight = height;
    // this.contenitore.nativeElement.style.height.px = this.contentHeight;
  }

  getFaq(idcategoria, lingua) {
    this.faqService.getFaq(idcategoria, lingua)
      .subscribe(result => {
        this.faqs = result;
      });
  }

  getAttivo() {
    return this.stripeService.loading;
  }

  isFormsValid() {
    if (this.formCarrello.valid) {
      if (this.isPresentWine()) {
        if (this.formSpedizione.valid) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    } else {
      return false;
    }
  }

  gestisciAvanzamento() {

    const valoriForms = {
      formCarrello: this.formCarrello.value,
      formSpedizione: this.formSpedizione.value,
      formTipoPagamento: this.formTipoPagamento.value,
      salvata: true
    }

    this.clientiService.setFormCliente(valoriForms);

    if (this.paeseSpedizione && this.paeseSpedizione === 'WW') {
      this.salvaDatiSpedizioneEstera();
    } else {
      if (this.checkPagamentoZero()) {
        this.preparaDatiPerAcquisto();
        this.setStep(3);
      } else {
        this.nextStep();
      }
    }

  }

  carrelloPieno() {
    if (this.carrelloBuoniCantina.length > 0 || this.carrelloVini.length > 0 || this.carrelloVisite.length > 0 || this.carrelloPacchetti.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  someVisite() {
    if (this.carrelloVisite.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  preparaDatiPerAcquisto() {
    if (
      this.formCarrello.valid &&
      (
        (this.formSpedizione.valid && this.isPresentWine()) ||
        (!this.isPresentWine()) ||
        (this.isPresentWine() && this.pagamentoWineshopSC)
      )
    ) {

      const def = {
        noteordine: this.formCarrello.value.noteOrdine,
        tipoPagamento: this.formTipoPagamento.value.tipoPagamento,
        isCodiceFormMasterPresente: this.isCodiceFormMasterPresente
      }

      const fiscali = {
        tipoDocFormControl: this.formCarrello.value.tipoDocFormControl,
        denominazione_f: this.formCarrello.value.fDenominazione,
        indirizzo_f: this.formCarrello.value.fIndirizzo,
        cap_f: this.formCarrello.value.fCap,
        citta_f: this.formCarrello.value.fCitta,
        provincia_f: this.formCarrello.value.fProvincia,
        cf_f: this.formCarrello.value.fPiva,
        fe_f: this.formCarrello.value.fFe,
        nome_r: this.formCarrello.value.nome_r,
        cognome_r: this.formCarrello.value.cognome_r,
        indirizzo_r: this.formCarrello.value.indirizzo_r,
        cap_r: this.formCarrello.value.cap_r,
        citta_r: this.formCarrello.value.citta_r,
        provincia_r: this.formCarrello.value.provincia_r,
        cf_r: this.formCarrello.value.cf_r
      }

      const utente = {
        tipo: 'clienteNF',
        codiceForm: this.getCodiceFormCarrello(),
        email: this.formCarrello.value.email,
        nome: this.formCarrello.value.nome,
        cognome: this.formCarrello.value.cognome,
        nazione: this.formCarrello.value.nazione,
        cap: this.formCarrello.value.cap,
        telefono: this.formCarrello.value.telefono,
        p1: this.formCarrello.value.p1,
        p2: this.formCarrello.value.p2,
        p3: this.formCarrello.value.p3,
        idFacebook: null,
        idGoogle: null,
        profileImage: null,
        idCookie: this.messageService.getIdCookie(),
        tipoDocFormControl: this.formCarrello.value.tipoDocFormControl,
        denominazione_f: this.formCarrello.value.fDenominazione,
        indirizzo_f: this.formCarrello.value.fIndirizzo,
        cap_f: this.formCarrello.value.fCap,
        citta_f: this.formCarrello.value.fCitta,
        provincia_f: this.formCarrello.value.fProvincia,
        cf_f: this.formCarrello.value.fPiva,
        fe_f: this.formCarrello.value.fFe,
        nome_r: this.formCarrello.value.nome_r,
        cognome_r: this.formCarrello.value.cognome_r,
        indirizzo_r: this.formCarrello.value.indirizzo_r,
        cap_r: this.formCarrello.value.cap_r,
        citta_r: this.formCarrello.value.citta_r,
        provincia_r: this.formCarrello.value.provincia_r,
        cf_r: this.formCarrello.value.cf_r,
        animali: this.check_animali,
        vegani: this.check_vegani ? this.count_vegani : 0,
        vegetariani: this.check_vegetariani ? this.count_vegetariani : 0,
        celiaci: this.check_celiaci ? this.count_celiaci : 0
      }

      this.formCarrello.updateValueAndValidity();
      this.formSpedizione.updateValueAndValidity();

      if (!this.checkPagamentoZero()) {
        this.nextStep();
      }

      this.valori = {
        default: def,
        fiscali: fiscali,
        spedizione: this.formSpedizione.value,
        utente: utente,
        listaCodiciScontoCarrello: this.listaCodiciScontoCarrello
      };

    } else {
      if (this.formCarrello.invalid) {
        this.markFormGroupTouched(this.formCarrello);
      }
      if (this.isPresentWine() && this.formSpedizione.invalid) {
      }
      document.querySelector('#formcarrello').scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  private markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control.controls) {
        control.controls.forEach(c => this.markFormGroupTouched(c));
      }
    });
  }


  rimuoviDalCarrelloBuoniCantina(idcarrello_buoni_cantina) {
    this.loadingCarrello = true;
    this.carrelloService.rimuoviDalCarrelloBuoniCantina(idcarrello_buoni_cantina, null)
      .subscribe(result => {
        if (result['risultato'] === true) {
          this.caricaCarrello();
        } else {
        }
      });
  }

  rimuoviDalCarrello(idcarrello) {
    this.loadingCarrello = true;
    this.carrelloService.rimuoviDalCarrello(idcarrello, null)
      .subscribe(result => {
        if (result['risultato'] === true) {
          this.caricaCarrello();
        } else {
        }
      });
  }

  rimuoviDalCarrelloSC(idcarrelloSC) {
    this.loadingCarrello = true;
    this.carrelloService.rimuoviDalCarrelloSC(idcarrelloSC, null)
      .subscribe(result => {
        if (result['risultato'] === true) {
          this.caricaCarrello();
        } else {
        }
      });
  }

  rimuoviDalCarrelloVini(riga) {
    let ids = [];
    for (const vino of riga.vini) {
      ids.push(vino.idcarrello_vini);
    }
    this.loadingCarrello = true;
    this.carrelloService.rimuoviDalCarrelloVini(ids, null)
      .subscribe(result => {
        if (result['risultato'] === true) {
          this.caricaCarrello();
        } else {
        }
      });
  }

  rimuoviDalCarrelloPacchetti(idcarrello) {
    this.loadingCarrello = true;
    this.carrelloService.rimuoviDalCarrelloPacchetti(idcarrello, null)
      .subscribe(result => {
        if (result['risultato'] === true) {
          this.caricaCarrello();
        } else {
        }
      });
  }

  rimuoviDalCarrelloVinoSingolo(id) {
    this.loadingCarrello = true;
    this.carrelloService.rimuoviDalCarrelloVinoSingolo(id, null)
      .subscribe(result => {
        if (result['risultato'] === true) {
          this.caricaCarrello();
        } else {
        }
      });
  }

  chiudiBooking() {
    this.messageService.chiudiBooking();
  }

  canPayCC() {
    let ok = true;
    for (const c of this.carrelloVisite) {
      if (c.pcarta === '1' && this.controllaCantinaSC()) {
        ok = false;
      }
    }
    return ok;
  }

  get usaStripeCantina(): boolean {
    let result = true;
    return result;
  }

  setPaeseSpedizione(sigla) {
    if (this.paeseSpedizione && this.paeseSpedizione === sigla) {
    } else {
      this.paeseSpedizione = sigla;
    }
  }

  salvaDatiSpedizioneEstera() {

    if (this.formSpedizione.valid) {
      this.loadingEstero = true;
      const valori = {
        spedizione: this.formSpedizione.value,
        cliente: this.formCarrello.value,
        tipo: 'inviaRichiestaSpedizioneEstera',
        insite: true,
        fakeSite: false,
        codiceForm: this.getCodiceFormCarrello(),
        lang: this.translate.currentLang
      };
      valori.spedizione.telefono_sp = '(' + valori.spedizione.prefix + ') ' + valori.spedizione.telefono_sp;
      valori.cliente.idCookie = this.messageService.getIdCookie();

      this.clientiService.inviaRichiestaSpedizioneEstera(valori).subscribe(response => {
        if (response && response.risultato) {
          for (const vini of this.carrelloVini) {
            for (const vino of vini.vini) {
              vino.in_attesa = 1;
              vino.spedizione_estera = 1;
            }
          }
          for (const pacchetti of this.carrelloPacchetti) {
            for (const pacchetto of pacchetti.pacchetti) {
              pacchetto.in_attesa = 1;
              pacchetto.spedizione_estera = 1;
            }
          }

          this.erroreEstero = false;
        } else {
          this.erroreEstero = true;
        }
        this.setStep(4)
        this.loadingEstero = false;
      });
    } else {
      this.markFormGroupTouched(this.formSpedizione);
    }
  }

  canInsertCodiciScontoCarrello() {
    let isOK = false;
    for (const riga of this.carrelloVini) {
      if (riga.info_codici.tot_codici > 0) {
        isOK = true;
      }
    }
    return isOK;
  }

  controllaCodiceScontoCarrello() {
    this.loadingCodici = true;
    this.carrelloService.controllaCodiceScontoCarrello(this.codiceScontoCarrello).subscribe(response => {
      if (response && response.length > 0) {
        for (const codice_in_arrivo of response) {
          if (codice_in_arrivo.attivo === '1') {

            const presente = this.listaCodiciScontoCarrello.filter(codice => codice.codice === codice_in_arrivo.codice && codice.idCantina === codice_in_arrivo.idCantina).length > 0 ? true : false;
            if (!presente) {

              const is_associato = this.carrelloVini.filter(cantina => cantina.idCantina === codice_in_arrivo.idCantina).length > 0 ? true : false;
              const cantina_associata = this.carrelloVini.filter(cantina => cantina.idCantina === codice_in_arrivo.idCantina).length > 0 ?
                this.carrelloVini.filter(cantina => cantina.idCantina === codice_in_arrivo.idCantina)[0] : null;

              let valido = true;

              if (is_associato && cantina_associata) {
                const codici_gia_associati = this.listaCodiciScontoCarrello.filter(codice => codice.idCantina === codice_in_arrivo.idCantina).length > 0 ? true : false;

                if (codici_gia_associati) {
                  if (cantina_associata.info_codici.cumulabili === '0') {

                    const initialState = {
                      codice: codice_in_arrivo,
                      carrello: cantina_associata,
                      errore: true,
                      tipo_errore: 'cumulabili',
                      inserito: false,
                    }
                    const dialogRef = this.dialog.open(DialogScontoCarrelloAlertComponent, {
                      width: '250px',
                      data: initialState
                    });
                  } else {
                    this.gestisciValiditaCodiceSconto(codice_in_arrivo, cantina_associata, valido);
                  }
                } else {
                  this.gestisciValiditaCodiceSconto(codice_in_arrivo, cantina_associata, valido);
                }
              }
            } else {
              const initialState = {
                codice: codice_in_arrivo,
                carrello: null,
                errore: true,
                tipo_errore: 're-insert',
                inserito: false
              }
              const dialogRef = this.dialog.open(DialogScontoCarrelloAlertComponent, {
                width: '250px',
                data: initialState
              });
            }
          } else {
            const initialState = {
              codice: codice_in_arrivo,
              carrello: null,
              errore: true,
              tipo_errore: 'no-active',
              inserito: false
            }
            const dialogRef = this.dialog.open(DialogScontoCarrelloAlertComponent, {
              width: '250px',
              data: initialState
            });
          }
        }
      } else {
        const initialState = {
          codice: { codice: this.codiceScontoCarrello },
          carrello: null,
          errore: true,
          tipo_errore: 'no-exist',
          inserito: false
        }
        const dialogRef = this.dialog.open(DialogScontoCarrelloAlertComponent, {
          width: '250px',
          data: initialState
        });
      }

      this.loadingCodici = false;
    });
  }

  gestisciValiditaCodiceSconto(response, cantina_associata, valido) {
    if (response.tipo_codice === '1') {
      if (parseInt(response.minimo_bottiglie, 10) <= parseInt(cantina_associata.qta_abilitati, 10)) {
        valido = true;
      } else {
        valido = false;
      }
    } else {
      if (parseFloat(response.minimo_totale) <= parseFloat(cantina_associata.totale_abilitati)) {
        valido = true;
      } else {
        valido = false;
      }
    }

    if (valido) {
      this.listaCodiciScontoCarrello = [...this.listaCodiciScontoCarrello, response];
      this.codiceScontoCarrello = '';

      const initialState = {
        codice: response,
        carrello: cantina_associata,
        errore: false,
        tipo_errore: null,
        inserito: true
      }
      const dialogRef = this.dialog.open(DialogScontoCarrelloAlertComponent, {
        width: '250px',
        data: initialState
      });
    } else {
      const initialState = {
        codice: response,
        carrello: cantina_associata,
        errore: false,
        tipo_errore: null,
        inserito: false
      }
      const dialogRef = this.dialog.open(DialogScontoCarrelloAlertComponent, {
        width: '250px',
        data: initialState
      });
    }
  }

  rimuoviCodiceScontoVino(codice) {
    const nuovoArray = this.listaCodiciScontoCarrello.filter(item => item !== codice);
    this.listaCodiciScontoCarrello = nuovoArray;
  }

  checkCodiciSconto() {
    const lista = this.listaCodiciScontoCarrello;
    for (const codice of lista) {
      const righe_associate = this.carrelloVini.filter(riga => riga.idCantina === codice.idCantina);
      for (const riga of righe_associate) {
        if (codice.tipo_codice === '1') {
          if (parseInt(codice.minimo_bottiglie, 10) > parseInt(riga.qta_abilitati, 10)) {
            this.listaCodiciScontoCarrello = this.listaCodiciScontoCarrello.filter(codice_trovato => codice_trovato.codice !== codice.codice)
          }
        } else {
          if (parseFloat(codice.minimo_totale) > parseFloat(riga.totale_abilitati)) {
            this.listaCodiciScontoCarrello = this.listaCodiciScontoCarrello.filter(codice_trovato => codice_trovato.codice !== codice.codice)
          }
        }
      }
    }
  }

  get count_biglietti(): number {
    let count = 0;
    if (this.carrelloVisite && this.carrelloVisite.length > 0) {
      count += parseInt(this.carrelloVisite[0]['nadulti']);
      count += parseInt(this.carrelloVisite[0]['nridotti']);
      count += parseInt(this.carrelloVisite[0]['nminori']);
    }
    return count;
  }

  setAddons(addon, increase) {
    switch (addon) {
      case 1:
        if (increase) {
          if (this.count_vegani < this.count_biglietti) {
            this.count_vegani++;
          }
        } else {
          if (this.count_vegani > 0) {
            this.count_vegani--;
            if (this.count_vegani == 0) {
              this.check_vegani = false;
            }
          }
        }
        break;
      case 2:
        if (increase) {
          if (this.count_vegetariani < this.count_biglietti) {
            this.count_vegetariani++;
          }
        } else {
          if (this.count_vegetariani > 0) {
            this.count_vegetariani--;
            if (this.count_vegetariani == 0) {
              this.check_vegetariani = false;
            }
          }
        }
        break;
      case 3:
        if (increase) {
          if (this.count_celiaci < this.count_biglietti) {
            this.count_celiaci++;
          }
        } else {
          if (this.count_celiaci > 0) {
            this.count_celiaci--;
            if (this.count_celiaci == 0) {
              this.check_celiaci = false;
            }
          }
        }
        break;
    }
  }

}
